import { Loader } from "rsuite";

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  name: string;
  loading?: boolean;
};

export function Button({
  name,
  ref: _,
  className,
  loading,
  ...props
}: Props): JSX.Element {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={`btn btn-sm ${className ? ` ${className}` : ""}`}
    >
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <span className="me-2">{name}</span> <Loader />
        </div>
      ) : (
        name
      )}
    </button>
  );
}
